<template>
  <div class="container-wrapper">
    <div class="banner">
      <img src="https://filestorage.gtdreamlife.com/test/16550908773221e5003d98d4d43e0b8ce0c5dfe911a50.jpg" alt="banner">
    </div>
    <div class="container">
      <el-tabs 
        tab-position="left" 
        class="leftNav" 
        v-model="applyTagId" 
        @tab-click="handleClick"
      >
        <el-tab-pane 
          v-for="(item,index) in list" 
          :key="index"
          :name="item.id"
        >
          <span slot="label">{{item.name}}
            <span> ({{item.countApply}})</span>
          </span>
        </el-tab-pane>
        <!-- <el-tab-pane label="生活美" name="beautyLifeApplys"></el-tab-pane>
        <el-tab-pane label="产业美" name="beautyIndustry"></el-tab-pane>
        <el-tab-pane label="人文美" name="beautyHumanityApplys"></el-tab-pane>
        <el-tab-pane label="治理美" name="beautyGovernace"></el-tab-pane> -->
      </el-tabs>

      <AppList
        type="mine"
        :dataSource="applicationList"
        :pagination="pagination"
        :onChange="handlePaginationChange"
        :requery="fetch"
        :loading="loading"
        :hasKeyword="!!hasKeyword"
        :categoryId="categoryId"
        @setType="setType"
        :nav='navObj'
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AppList from '@/components/AppList/tzIndex'
import { GetYiWuList } from '@/services/application'

export default {
  data () {
    return {
      type: '1',
      categoryId: '',
      applyTagId: '0',
      list:[],
      navObj: null
    }
  },
  computed: {
    ...mapState({
      applicationList: state => state.application.YiWuApplicationList,
      pagination: state => state.application.YiWupagination,
      townId: state => state.user.townId,
      loading: state => state['@@loading'].effects['application/fetchYiWuApplicationList']
    }),
    hasKeyword () {
      return this.$route.query.keyword
    }
  },
  components: {
    AppList
  },
  watch: {
    '$route.query.keyword' (after) {
      this.fetch(1)
    },
    townId () {
      this.getNavList()
      this.fetch(1)
    },
    list() {
      this.list.map((item) => {
        if (item.id === this.applyTagId) {
          this.navObj = item
        }
      })
    },
    applyTagId () {
      this.list.map((item) => {
        if (item.id === this.applyTagId) {
          this.navObj = item
        }
      })
    }
  },
  methods: {
    ...mapActions('application', ['fetchYiWuApplicationList']),
    handlePaginationChange (page) {
      this.fetch(page)
    },
    fetch (page) {
      const { keyword } = this.$route.query
      const { townId, pagination,applyTagId, type } = this
      this.fetchYiWuApplicationList({
        p: page || pagination.page,
        c: 12,
        townId,
        applyTagId,
        name: keyword,
        type
      })
    },
    setType(val) {
      this.type = val
      this.fetch(1)
    },
    handleClick() {
      this.fetch(1)
    },
    // 获取导航列表
    getNavList(){
      const { townId } = this
      GetYiWuList({townId}).then(res=>{
        if(res.code === '0'){
          res.data.forEach((item)=>{
            item.id = String(item.id)
          })
          this.list = res.data
        }
      })
    }
  },
  created () {
    this.fetch(1)
    this.getNavList()
  }
}
</script>

<style lang="less" scoped>
.container-wrapper {
  background: #f4f5f6;
  padding-bottom: 24px;
  height: 100%;
  min-width: 1200px;
  .banner{
    width: 100%;
    img{
      width: 100%;
    }
  }
}
.container {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  padding-top: 24px;
  padding-bottom: 24px;
}
.leftNav{
  width: 276px;
  background: #fff;
  margin-right: 32px;
  box-sizing: border-box;
  flex: 0 0 276px;
  padding-top: 20px;
  padding-left: 10px;
  padding-bottom: 20px;
  /deep/ .el-tabs__nav {
    margin: 0 auto;
  }
  /deep/ .el-tabs__header{
    margin: 0;
    width: 100%;
  }
  /deep/ .el-tabs__active-bar.is-left{
    display: none;
  }
  /deep/ .el-tabs__item{
    width: 100%;
    text-align: left;
    font-size: 16px;
    color: #333;
    line-height: 50px;
    height: 50px !important;
  }
  /deep/ .el-tabs__item.is-active{
    color: #1890FF !important;
  }
}
.search-title {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0.12px;
  line-height: 24px;
  margin-bottom: 14px;
}
.title-info {
  margin-top: 40px;
  margin-bottom: 24px;
  display: inline-flex;
  align-items: center;
  width: 100%;
  .title {
    font-weight: 500;
    font-size: 20px;
    color: #333333;
    letter-spacing: 0;
    margin-bottom: 0;
  }
  .sub-title {
    font-family: PingFang-SC-Regular;
    font-size: 14px;
    color: #999999;
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/taizhou/index.vue